// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var EmailSenderPopUp$ReactHooksTemplate = require("../common/EmailSenderPopUp.res.js");

var emptyState_selectedFromId = EmailFromId$ReactHooksTemplate.empty();

var emptyState = {
  fromIds: /* [] */0,
  selectedFromId: emptyState_selectedFromId,
  loading: true,
  form: false,
  notification: undefined,
  confirmationAction: undefined,
  error: undefined
};

function validateEmailFormat(email) {
  var trimmedEmail = email.trim();
  var emailValue = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, trimmedEmail);
  if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isValid, emailValue)) {
    return false;
  } else {
    return !Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, emailValue);
  }
}

function SenderEmails(props) {
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  console.log(state);
  React.useEffect((function (param) {
          Js_promise.$$catch((function (err) {
                  Curry._1(setState, (function (state) {
                          return {
                                  fromIds: state.fromIds,
                                  selectedFromId: state.selectedFromId,
                                  loading: false,
                                  form: state.form,
                                  notification: state.notification,
                                  confirmationAction: state.confirmationAction,
                                  error: state.error
                                };
                        }));
                  return Promise.resolve((console.log(err), undefined));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(Curry._1(setState, (function (state) {
                                        return {
                                                fromIds: Belt_List.fromArray(Json_decode.field("email_from_ids", (function (param) {
                                                            return Json_decode.array(EmailFromId$ReactHooksTemplate.decode, param);
                                                          }), json)),
                                                selectedFromId: state.selectedFromId,
                                                loading: false,
                                                form: state.form,
                                                notification: state.notification,
                                                confirmationAction: state.confirmationAction,
                                                error: state.error
                                              };
                                      })));
                    }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/email_from_ids")));
        }), []);
  var toggleForm = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    fromIds: state.fromIds,
                    selectedFromId: state.selectedFromId,
                    loading: state.loading,
                    form: !state.form,
                    notification: state.notification,
                    confirmationAction: state.confirmationAction,
                    error: state.error
                  };
          }));
  };
  var updateSenderEmail = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var frmId = EmailFromId$ReactHooksTemplate.setFromId(state.selectedFromId, value);
    Curry._1(setState, (function (state) {
            return {
                    fromIds: state.fromIds,
                    selectedFromId: frmId,
                    loading: state.loading,
                    form: state.form,
                    notification: state.notification,
                    confirmationAction: state.confirmationAction,
                    error: state.error
                  };
          }));
  };
  var toggleDefault = function (param) {
    if (EmailFromId$ReactHooksTemplate.default(state.selectedFromId)) {
      return Curry._1(setState, (function (state) {
                    return {
                            fromIds: state.fromIds,
                            selectedFromId: EmailFromId$ReactHooksTemplate.toggledefault(state.selectedFromId),
                            loading: state.loading,
                            form: state.form,
                            notification: state.notification,
                            confirmationAction: state.confirmationAction,
                            error: state.error
                          };
                  }));
    } else {
      return Curry._1(setState, (function (state) {
                    return {
                            fromIds: state.fromIds,
                            selectedFromId: state.selectedFromId,
                            loading: state.loading,
                            form: state.form,
                            notification: state.notification,
                            confirmationAction: "DefaultSenderEmail",
                            error: state.error
                          };
                  }));
    }
  };
  var handleSubmit = function (fromId) {
    var params = {};
    params["email_from_ids"] = EmailFromId$ReactHooksTemplate.encode(fromId);
    var id = EmailFromId$ReactHooksTemplate.id(fromId);
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              var message = id !== undefined ? "Sender email updated" : "Sender email created";
              Curry._1(setState, (function (state) {
                      return {
                              fromIds: state.fromIds,
                              selectedFromId: state.selectedFromId,
                              loading: state.loading,
                              form: !state.form,
                              notification: {
                                TAG: "Success",
                                _0: message
                              },
                              confirmationAction: state.confirmationAction,
                              error: state.error
                            };
                    }));
              window.location.reload();
            } else {
              var error = Json_decode.field("errors", (function (param) {
                      return Json_decode.withDefault("failed", Json_decode.string, param);
                    }), response);
              Curry._1(setState, (function (state) {
                      return {
                              fromIds: state.fromIds,
                              selectedFromId: state.selectedFromId,
                              loading: state.loading,
                              form: !state.form,
                              notification: {
                                TAG: "Failure",
                                _0: error
                              },
                              confirmationAction: state.confirmationAction,
                              error: state.error
                            };
                    }));
            }
            return Promise.resolve();
          }), id !== undefined ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids/" + String(id) + "/update", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids", params));
  };
  var form = function (param) {
    return JsxRuntime.jsx(EmailSenderPopUp$ReactHooksTemplate.make, {
                isOpen: state.form,
                onClose: toggleForm,
                selectedFromId: state.selectedFromId,
                onUpdateEmail: updateSenderEmail,
                onToggleDefault: toggleDefault,
                onSubmit: handleSubmit,
                isDisabled: EmailFromId$ReactHooksTemplate.fromId(state.selectedFromId).length === 0,
                existingEmails: state.fromIds
              });
  };
  var alertType = state.notification;
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                              alertType: alertType,
                              handleClose: (function (param) {
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  fromIds: state.fromIds,
                                                  selectedFromId: state.selectedFromId,
                                                  loading: state.loading,
                                                  form: state.form,
                                                  notification: undefined,
                                                  confirmationAction: state.confirmationAction,
                                                  error: state.error
                                                };
                                        }));
                                })
                            }),
                        className: "fixed top-4 right-4 z-50"
                      }) : null,
                state.loading ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: "Loading Sender Emails...",
                                                  className: "text-gray-600"
                                                })
                                          ],
                                          className: "flex items-center space-x-3"
                                        }),
                                    className: "flex items-center justify-center py-20"
                                  }),
                              className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                            }),
                        className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
                      }) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("span", {
                                                                children: "📤",
                                                                className: "text-xl"
                                                              }),
                                                          className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h1", {
                                                                  children: "Sender Email Addresses",
                                                                  className: "text-2xl font-bold text-gray-900"
                                                                }),
                                                            JsxRuntime.jsx("p", {
                                                                  children: "Manage sender email addresses and configure the default sender address.",
                                                                  className: "text-sm text-gray-600 mt-1"
                                                                })
                                                          ]
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-3"
                                                }),
                                            className: "flex items-center justify-between"
                                          }),
                                      className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                                    }),
                                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                              }),
                          state.form ? form() : null,
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                children: "📧",
                                                                className: "text-lg"
                                                              }),
                                                          JsxRuntime.jsx("h2", {
                                                                children: "Email List",
                                                                className: "text-lg font-bold text-gray-900"
                                                              }),
                                                          JsxRuntime.jsx("span", {
                                                                children: String(List.length(state.fromIds)) + " Emails",
                                                                className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                              })
                                                        ],
                                                        className: "flex items-center space-x-2"
                                                      }),
                                                  JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("span", {
                                                                children: "+",
                                                                className: "mr-2"
                                                              }),
                                                          "Add New Sender Email"
                                                        ],
                                                        className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                        onClick: (function (param) {
                                                            Curry._1(setState, (function (state) {
                                                                    return {
                                                                            fromIds: state.fromIds,
                                                                            selectedFromId: EmailFromId$ReactHooksTemplate.empty(),
                                                                            loading: state.loading,
                                                                            form: state.form,
                                                                            notification: state.notification,
                                                                            confirmationAction: state.confirmationAction,
                                                                            error: state.error
                                                                          };
                                                                  }));
                                                            toggleForm();
                                                          })
                                                      })
                                                ],
                                                className: "flex items-center justify-between"
                                              }),
                                          JsxRuntime.jsx("p", {
                                                children: "Manage email sender addresses and choose a default",
                                                className: "text-sm text-gray-600 mt-1"
                                              })
                                        ],
                                        className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: List.length(state.fromIds) > 0 ? JsxRuntime.jsxs("table", {
                                                children: [
                                                  JsxRuntime.jsx("thead", {
                                                        children: JsxRuntime.jsxs("tr", {
                                                              children: [
                                                                JsxRuntime.jsx("th", {
                                                                      children: "Sender Email",
                                                                      className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                    }),
                                                                JsxRuntime.jsx("th", {
                                                                      children: "Default",
                                                                      className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                    }),
                                                                JsxRuntime.jsx("th", {
                                                                      children: "Actions",
                                                                      className: "text-left py-3 px-4 font-medium text-gray-700"
                                                                    })
                                                              ]
                                                            }),
                                                        className: "bg-gray-50 border-b border-gray-200"
                                                      }),
                                                  JsxRuntime.jsx("tbody", {
                                                        children: $$Array.of_list(Belt_List.map(state.fromIds, (function (fromId) {
                                                                    return JsxRuntime.jsxs("tr", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("td", {
                                                                                        children: JsxRuntime.jsx("span", {
                                                                                              children: EmailFromId$ReactHooksTemplate.fromId(fromId),
                                                                                              className: "text-sm font-medium text-gray-900"
                                                                                            }),
                                                                                        className: "py-4 px-4"
                                                                                      }),
                                                                                  JsxRuntime.jsx("td", {
                                                                                        children: JsxRuntime.jsx("span", {
                                                                                              children: Pervasives.string_of_bool(EmailFromId$ReactHooksTemplate.default(fromId)),
                                                                                              className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                                                            }),
                                                                                        className: "py-4 px-4"
                                                                                      }),
                                                                                  JsxRuntime.jsx("td", {
                                                                                        children: JsxRuntime.jsxs("div", {
                                                                                              children: [
                                                                                                JsxRuntime.jsx("button", {
                                                                                                      children: JsxRuntime.jsx("img", {
                                                                                                            className: "h-4 w-4",
                                                                                                            src: Image$ReactHooksTemplate.edit
                                                                                                          }),
                                                                                                      className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                                      title: "Edit sender email",
                                                                                                      onClick: (function (param) {
                                                                                                          Curry._1(setState, (function (state) {
                                                                                                                  return {
                                                                                                                          fromIds: state.fromIds,
                                                                                                                          selectedFromId: fromId,
                                                                                                                          loading: state.loading,
                                                                                                                          form: state.form,
                                                                                                                          notification: state.notification,
                                                                                                                          confirmationAction: state.confirmationAction,
                                                                                                                          error: state.error
                                                                                                                        };
                                                                                                                }));
                                                                                                          toggleForm();
                                                                                                        })
                                                                                                    }),
                                                                                                JsxRuntime.jsx("button", {
                                                                                                      children: JsxRuntime.jsx("img", {
                                                                                                            className: "h-4 w-4",
                                                                                                            src: Image$ReactHooksTemplate.trash
                                                                                                          }),
                                                                                                      className: "p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200",
                                                                                                      title: "Delete sender email",
                                                                                                      onClick: (function (param) {
                                                                                                          var id = EmailFromId$ReactHooksTemplate.id(fromId);
                                                                                                          Js_promise.then_((function (response) {
                                                                                                                  var status = Json_decode.field("status", (function (param) {
                                                                                                                          return Json_decode.withDefault("failed", Json_decode.string, param);
                                                                                                                        }), response);
                                                                                                                  if (status === "success") {
                                                                                                                    var newList = Belt_List.keep(state.fromIds, (function (x) {
                                                                                                                            return Caml_obj.notequal(EmailFromId$ReactHooksTemplate.id(x), EmailFromId$ReactHooksTemplate.id(fromId));
                                                                                                                          }));
                                                                                                                    Curry._1(setState, (function (state) {
                                                                                                                            return {
                                                                                                                                    fromIds: newList,
                                                                                                                                    selectedFromId: state.selectedFromId,
                                                                                                                                    loading: state.loading,
                                                                                                                                    form: state.form,
                                                                                                                                    notification: {
                                                                                                                                      TAG: "Success",
                                                                                                                                      _0: "Deleted Successfully"
                                                                                                                                    },
                                                                                                                                    confirmationAction: state.confirmationAction,
                                                                                                                                    error: state.error
                                                                                                                                  };
                                                                                                                          }));
                                                                                                                  } else {
                                                                                                                    Curry._1(setState, (function (state) {
                                                                                                                            return {
                                                                                                                                    fromIds: state.fromIds,
                                                                                                                                    selectedFromId: state.selectedFromId,
                                                                                                                                    loading: state.loading,
                                                                                                                                    form: state.form,
                                                                                                                                    notification: {
                                                                                                                                      TAG: "Failure",
                                                                                                                                      _0: "Failed to delete"
                                                                                                                                    },
                                                                                                                                    confirmationAction: state.confirmationAction,
                                                                                                                                    error: state.error
                                                                                                                                  };
                                                                                                                          }));
                                                                                                                  }
                                                                                                                  return Promise.resolve();
                                                                                                                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids/" + String(Belt_Option.getExn(id)) + "/delete", {}));
                                                                                                        })
                                                                                                    })
                                                                                              ],
                                                                                              className: "flex items-center space-x-2"
                                                                                            }),
                                                                                        className: "py-4 px-4"
                                                                                      })
                                                                                ],
                                                                                className: "hover:bg-gray-50 transition-all duration-200 hover:shadow-sm"
                                                                              }, String(Belt_Option.getWithDefault(EmailFromId$ReactHooksTemplate.id(fromId), 0)));
                                                                  }))),
                                                        className: "divide-y divide-gray-100"
                                                      })
                                                ],
                                                className: "w-full text-sm"
                                              }) : JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsx("span", {
                                                                    children: "📧",
                                                                    className: "text-2xl text-gray-400"
                                                                  }),
                                                              className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                                            }),
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("h3", {
                                                                      children: "No Sender Email Found",
                                                                      className: "text-lg font-medium text-gray-900"
                                                                    }),
                                                                JsxRuntime.jsx("p", {
                                                                      children: "Get started by Creating Your First Sender Email",
                                                                      className: "text-sm text-gray-500 mt-1"
                                                                    })
                                                              ]
                                                            }),
                                                        JsxRuntime.jsxs("button", {
                                                              children: [
                                                                JsxRuntime.jsx("span", {
                                                                      children: "+",
                                                                      className: "mr-2"
                                                                    }),
                                                                "Add Your First Sender Email"
                                                              ],
                                                              className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                              onClick: (function (param) {
                                                                  Curry._1(setState, (function (state) {
                                                                          return {
                                                                                  fromIds: state.fromIds,
                                                                                  selectedFromId: EmailFromId$ReactHooksTemplate.empty(),
                                                                                  loading: state.loading,
                                                                                  form: state.form,
                                                                                  notification: state.notification,
                                                                                  confirmationAction: state.confirmationAction,
                                                                                  error: state.error
                                                                                };
                                                                        }));
                                                                  toggleForm();
                                                                })
                                                            })
                                                      ],
                                                      className: "flex flex-col items-center space-y-4"
                                                    }),
                                                className: "text-center py-12"
                                              }),
                                        className: "overflow-x-auto"
                                      })
                                ],
                                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                              })
                        ],
                        className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
                      })
              ],
              className: "h-full bg-gray-50"
            });
}

var make = SenderEmails;

exports.emptyState = emptyState;
exports.validateEmailFormat = validateEmailFormat;
exports.make = make;
/* emptyState Not a pure module */
